<template>
    <div class="apprentice-tab-buttons">
        <design-2021-apprentice-multiselect-component
            class="project-switcher with-border"
            id="select-project"
            v-if="!$authUser.isStudent()"
            v-model="selectedProject"
            label="title"
            track-by="id"
            :options="groupIn.projects"
            :multiple-select="false"
            @input="redirectToNewProject()">
        </design-2021-apprentice-multiselect-component>

        <b-badge
            class="badge-rating"
            v-if="hasRatingResult"
            pill
            variant="info">
            <i class="fas fa-fw fa-trophy"></i>{{ getResultValue }}
        </b-badge>

        <b-button
            class="btn-icon-only btn-primary-icon"
            v-if="project.type_id !== 2"
            variant="primary"
            :title="$t('paper.order')"
            data-toggle="tooltip"
            @click="onOrder"
            data-placement="bottom">
            <i class="fa fa-fw fa-shopping-basket"></i>
        </b-button>

        <b-button
            class="btn-icon-only btn-primary-icon"
            v-b-modal="'edit-project-modal'"
            v-if="canEditTitle && project.type_id !== 2"
            variant="primary"
            :title="$t('paper.edit_title')"
            data-toggle="tooltip"
            data-placement="bottom">
            <i class="fas fa-fw fa-pencil"></i>
        </b-button>

        <b-button
            class="btn-icon-only btn-primary-icon"
            v-if="canRate"
            v-b-modal="'portfolio-rating'"
            variant="primary"
            :title="$t('paper.review')"
            data-toggle="tooltip"
            data-placement="bottom">
            <i class="fa fa-fw fa-medal"></i>
        </b-button>

        <design-2021-paper-show-open-close-button-component
            v-if="project.type_id !== 2"
            :project-in="project">
        </design-2021-paper-show-open-close-button-component>

        <portfolio-show-rating-modal-component
            v-if="canRate"
            :rating-in="portfolio.portfolio_rating"
            key-name="portfolio-rating"
            :children-in="portfolio.categories"
            :child-title="$t('paper.category_results')"
            :title="$t('paper.portfolio_review')"
            @save-rating="savePortfolioRating($event)">
        </portfolio-show-rating-modal-component>

        <!--            todo gotta give portfolio it's own header-->
        <b-modal
            id="edit-project-modal"
            v-if="canEditTitle"
            ref="edit-project-modal"
            :title="$t('paper.edit_title')"
            :ok-disabled="!project.title"
            :ok-title="$t('common.save')"
            :cancel-title="$t('common.cancel')"
            cancel-variant="outline-primary"
            modal-class="apprentice-default-modal project-edit-modal"
            @ok="onOk()">
            <div class="row">
                <div class="col-md-12">
                    <label for="add-project-name-input">{{ $t('common.title') }}</label>
                    <b-form-input
                        id="edit-project-name-input"
                        v-model="project.title"
                        :placeholder="$t('common.title')">
                    </b-form-input>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: 'design-2021-paper-show-tab-buttons-component',
    props: ['projectIn', 'titleIn', 'canEditTitle', 'portfolioIn', 'groupIn'],
    data() {
        return {
            portfolio: this.portfolioIn,
            project: this.projectIn,
            title: this.titleIn,
            selectedProject: this.projectIn,
        };
    },
    computed: {
        canRate() {
            if (!this.portfolio) {
                return false;
            }
            return (
                !this.$authUser.isStudent() && this.portfolio.portfolio_rating && this.portfolio.portfolio_rating.type
            );
        },
        hasRatingResult() {
            if (!this.portfolio) {
                return false;
            }
            return this.portfolio.portfolio_rating && this.portfolio.portfolio_rating.results.length;
        },
        getResultValue() {
            if (!this.portfolio) {
                return null;
            }

            if (!this.portfolio.portfolio_rating || !this.portfolio.portfolio_rating.results.length) {
                return null;
            }

            if (this.portfolio.portfolio_rating.type === 1) {
                const id = this.portfolio.portfolio_rating.results[0].portfolio_rating_option_id;
                for (const option of this.portfolio.portfolio_rating.options) {
                    if (option.id === id) {
                        return option.value;
                    }
                }
            }

            if (this.portfolio.portfolio_rating.type === 2) {
                return this.portfolio.portfolio_rating.results[0].value;
            }

            return null;
        },
    },
    methods: {
        studentNames() {
            let student_names = this.projectIn.users
                .filter((user) => user.type === 'student')
                .map((student) => student.full_name);
            return student_names.join(', ');
        },
        onOrder() {
            window.location.href = this.routes.paperOrder(this.project.id);
        },
        onOk() {
            this.alert.saving();

            const data = {
                title: this.project.title,
            };

            this.axios.post(this.routes.baseUrl() + '/project/' + this.project.id + '/title', data).then(
                (response) => {
                    this.title = response.data.title;
                    window.location.href = this.routes.paperShow(this.projectIn.id);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        savePortfolioRating(values) {
            if (!values.rating.value && !values.rating.option_id && !this.portfolio.portfolio_rating.results.length) {
                return;
            }

            this.alert.saving();

            let data = values.rating;

            data.project_id = this.project.id;

            if (!this.portfolio.portfolio_rating.results.length) {
                this.axios.post(this.routes.portfolioRatingResult(), data).then(
                    (response) => {
                        this.portfolio.portfolio_rating.results = [response.data];
                        this.alert.success();
                        // this.fireClose(); todo
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            } else {
                this.axios.post(this.routes.portfolioRatingResultUpdate(), data).then(
                    (response) => {
                        if (response.data) {
                            this.portfolio.portfolio_rating.results = [response.data];
                        } else {
                            this.portfolio.portfolio_rating.results = [];
                        }

                        this.alert.success();
                        // if (!this.assignment.statuses || !this.assignment.statuses.length || this.assignment.statuses[0].status !== 1) {
                        //     this.fireClose();
                        // } else {
                        //     this.alert.success();
                        // } todo
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },
        redirectToNewProject() {
            window.location = this.routes.paperShow(this.selectedProject.id);
        },
    },
};
</script>

<style scoped lang="scss">
div.apprentice-tab-buttons {
    align-self: center;

    .btn {
        font-size: $base-font-size;

        &:not(.disabled) {
            i {
                font-size: $base-font-size;
                line-height: 1;
            }
        }
    }
}
</style>
